// extracted by mini-css-extract-plugin
export default {"button":"SNLink_button__XTCTU","disabled":"SNLink_disabled__OyowS","firstRenderTooltip":"SNLink_firstRenderTooltip__OJQf2"};